export const FETCH_MIDDLE_PANEL_DATA_REQUEST = "FETCH_MIDDLE_PANEL_DATA_REQUEST";
export const FETCH_MIDDLE_PANEL_DATA_SUCCESS = "FETCH_MIDDLE_PANEL_DATA_SUCCESS";
export const FETCH_MIDDLE_PANEL_DATA_ERROR = "FETCH_MIDDLE_PANEL_DATA_ERROR";

export const FETCH_MIDDLE_PANEL_FILTER_REQUEST = "FETCH_MIDDLE_PANEL_FILTER_REQUEST";
export const FETCH_MIDDLE_PANEL_FILTER_SUCCESS = "FETCH_MIDDLE_PANEL_FILTER_SUCCESS";
export const FETCH_MIDDLE_PANEL_FILTER_ERROR = "FETCH_MIDDLE_PANEL_FILTER_ERROR";
export const FETCH_REOPEN_REASON_LIST ="FETCH_REOPEN_REASON_LIST";
export const SET_REOPEN_REASON_LIST ="SET_REOPEN_REASON_LIST";

export const FETCH_MIDDLE_PANEL_NOTES_REQUEST = "FETCH_MIDDLE_PANEL_NOTES_REQUEST";
export const FETCH_MIDDLE_PANEL_NOTES_SUCCESS = "FETCH_MIDDLE_PANEL_NOTES_SUCCESS";
export const FETCH_MIDDLE_PANEL_NOTES_ERROR = "FETCH_MIDDLE_PANEL_NOTES_ERROR";

export const UPDATE_MIDDLE_PANEL_NOTES_REQUEST = "UPDATE_MIDDLE_PANEL_NOTES_REQUEST";
export const UPDATE_MIDDLE_PANEL_NOTES_SUCCESS = "UPDATE_MIDDLE_PANEL_NOTES_SUCCESS";
export const UPDATE_MIDDLE_PANEL_NOTES_ERROR = "UPDATE_MIDDLE_PANEL_NOTES_ERROR";

export const FETCH_MIDDLE_PANEL_WORKKARD_NOTES_REQUEST = "FETCH_MIDDLE_PANEL_WORKKARD_NOTES_REQUEST";
export const FETCH_MIDDLE_PANEL_WORKKARD_NOTES_SUCCESS = "FETCH_MIDDLE_PANEL_WORKKARD_NOTES_SUCCESS";
export const FETCH_MIDDLE_PANEL_WORKKARD_NOTES_ERROR = "FETCH_MIDDLE_PANEL_WORKKARD_NOTES_ERROR";

export const FETCH_MIDDLE_PANEL_FILE_REQUEST = "FETCH_MIDDLE_PANEL_FILE_REQUEST";
export const UPDATE_MIDDLE_PANEL_FILES_SUCCESS="UPDATE_MIDDLE_PANEL_FILES_SUCCESS";
export const FETCH_MIDDLE_PANEL_FILE_SUCCESS = "FETCH_MIDDLE_PANEL_FILE_SUCCESS";
export const FETCH_MIDDLE_PANEL_FILE_ERROR = "FETCH_MIDDLE_PANEL_FILE_ERROR";
export const FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS = "FETCH_MIDDLE_PANEL_WORKKARD_FILE_SUCCESS";

export const FETCH_MIDDLE_PANEL_DIARIES_REQUEST = "FETCH_MIDDLE_PANEL_DIARIES_REQUEST";
export const FETCH_MIDDLE_PANEL_DIARIES_SUCCESS = "FETCH_MIDDLE_PANEL_DIARIES_SUCCESS";
export const FETCH_MIDDLE_PANEL_DIARIES_ERROR = "FETCH_MIDDLE_PANEL_DIARIES_ERROR";
export const FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS = "FETCH_MIDDLE_PANEL_WORKKARD_DIARIES_SUCCESS";

export const FETCH_MIDDLE_PANEL_LOG_REQUEST = "FETCH_MIDDLE_PANEL_LOG_REQUEST";
export const FETCH_MIDDLE_PANEL_LOG_SUCCESS = "FETCH_MIDDLE_PANEL_LOG_SUCCESS";
export const FETCH_MIDDLE_PANEL_LOG_ERROR = "FETCH_MIDDLE_PANEL_LOG_ERROR";
export const FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS = "FETCH_MIDDLE_PANEL_WORKKARD_LOG_SUCCESS";

export const UPDATE_MIDDLE_PANEL_LOG_REQUEST = "UPDATE_MIDDLE_PANEL_LOG_REQUEST";
export const UPDATE_MIDDLE_PANEL_LOG_SUCCESS = "UPDATE_MIDDLE_PANEL_LOG_SUCCESS";
export const UPDATE_MIDDLE_PANEL_LOG_ERROR = "UPDATE_MIDDLE_PANEL_LOG_ERROR";


export const FETCH_MIDDLE_PANEL_PARTIES_REQUEST = "FETCH_MIDDLE_PANEL_PARTIES_REQUEST";
export const FETCH_MIDDLE_PANEL_PARTIES_SUCCESS = "FETCH_MIDDLE_PANEL_PARTIES_SUCCESS";
export const UPDATE_MIDDLE_PANEL_PARTIES_SUCCESS = "UPDATE_MIDDLE_PANEL_PARTIES_SUCCESS";

export const FETCH_MIDDLE_PANEL_PARTIES_ERROR = "FETCH_MIDDLE_PANEL_PARTIES_ERROR";
export const FETCH_MIDDLE_PANEL_WORKKARD_PARTIES_SUCCESS = "FETCH_MIDDLE_PANEL_WORKKARD_PARTIES_SUCCESS";

export const CHANGE_ACTIVITY_RESOLUTION_REQUEST = "CHANGE_ACTIVITY_RESOLUTION_REQUEST";
export const CHANGE_ACTIVITY_RESOLUTION_SUCCESS = "CHANGE_ACTIVITY_RESOLUTION_SUCCESS";
export const  CHANGE_ACTIVITY_RESOLUTION_ERROR = "CHANGE_ACTIVITY_RESOLUTION_ERROR";


export const WRITE_NOTE_REVIEW_REQUEST = "WRITE_NOTE_REVIEW_REQUEST";
export const WRITE_NOTE_REVIEW_SUCCESS = "WRITE_NOTE_REVIEW_SUCCESS";
export const WRITE_NOTE_REVIEW_ERROR = "WRITE_NOTE_REVIEW_ERROR";

export const RESET_MIDDLE_PANEL_INITIAL_STATE_REQUEST = "RESET_MIDDLE_PANEL_INITIAL_STATE_REQUEST";
export const RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS = "RESET_MIDDLE_PANEL_INITIAL_STATE_SUCCESS";
export const RESET_MIDDLE_PANEL_INITIAL_STATE_ERROR = "RESET_MIDDLE_PANEL_INITIAL_STATE_ERROR";


export const UPDATE_CAPTION="UPDATE_CAPTION";
export const UPDATE_CAPTION_SUCCESS="UPDATE_CAPTION_SUCCESS";

export const UPDATE_ACTIVITY_FIELD="UPDATE_ACTIVITY_FIELD";

export const RESET_MIDDLE_PANEL_INDIVIDUAL_TAB = "RESET_MIDDLE_PANEL_INDIVIDUAL_TAB";
export const RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS = "RESET_MIDDLE_PANEL_INDIVIDUAL_TAB_SUCCESS";
export const UPDATE_ACTIVITY_EXCLUDED_FILTER ="UPDATE_ACTIVITY_EXCLUDED_FILTER";

export const WORKKARD_TODO_OWNERS_REQUEST = "WORKKARD_TODO_OWNERS_REQUEST";
export const WORKKARD_TODO_OWNERS_SUCCESS = "WORKKARD_TODO_OWNERS_SUCCESS";

export const DIARIES_TITLE_EDIT_REQUEST = "DIARIES_TITLE_EDIT_REQUEST";
export const DIARIES_TITLE_EDIT_SUCCESS = "DIARIES_TITLE_EDIT_SUCCESS";
export const DIARIES_TITLE_EDIT_ERROR = "DIARIES_TITLE_EDIT_ERROR";

export const DIARIES_DUE_DATE_EDIT_REQUEST = "DIARIES_DUE_DATE_EDIT_REQUEST";
export const DIARIES_DUE_DATE_EDIT_SUCCESS = "DIARIES_DUE_DATE_EDIT_SUCCESS";
export const DIARIES_DUE_DATE_EDIT_ERROR = "DIARIES_DUE_DATE_EDIT_ERROR";

export const DIARIES_ACTION_COMPLETE_REQUEST = "DIARIES_ACTION_COMPLETE_REQUEST";
export const DIARIES_ACTION_COMPLETE_ERROR = "DIARIES_ACTION_COMPLETE_ERROR";
export const DIARIES_ACTION_COMPLETE_SUCCESS = "DIARIES_ACTION_COMPLETE_SUCCESS";

export const DIARIES_ACTION_CANCELLED_REQUEST = "DIARIES_ACTION_CANCELLED_REQUEST";
export const DIARIES_ACTION_CANCELLED_ERROR = "DIARIES_ACTION_CANCELLED_ERROR";
export const DIARIES_ACTION_CANCELLED_SUCCESS = "DIARIES_ACTION_CANCELLED_SUCCESS";

export const IS_LARGE_VIEW_ACTIVE="IS_LARGE_VIEW_ACTIVE";

export const IS_SELECT_ALL="IS_SELECT_ALL";

export const NOTES_ACTION_PUBLISH_SUCCESS = "NOTES_ACTION_PUBLISH_SUCCESS";
export const REMOVE_EDITED_NOTE = "REMOVE_EDITED_NOTE";
export const NOTES_ACTION_DELETE_SUCCESS = 'NOTES_ACTION_DELETE_SUCCESS';
export const UPDATE_MIDDLE_PANEL_REVIEW_SUCCESS = "UPDATE_MIDDLE_PANEL_REVIEW_SUCCESS";
export const UPDATE_REFRESH_NOTE_ID = "UPDATE_REFRESH_NOTE_ID";

export const NOTES_UPDATE_FILE_CAPTION='NOTES_UPDATE_FILE_CAPTION';
export const NOTES_UPDATE_FILE_CAPTION_SUCCESS='NOTES_UPDATE_FILE_CAPTION_SUCCESS';

export const DELETE_ASSOCIATED_PARTY_REQUEST="DELETE_ASSOCIATED_PARTY_REQUEST";
export const DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS ="DELETE_ASSOCIATED_PARTY_REQUEST_SUCCESS";

export const SHOW_MIDDLE_PANEL_LOADER="SHOW_MIDDLE_PANEL_LOADER";
export const HIDE_MIDDLE_PANEL_LOADER="HIDE_MIDDLE_PANEL_LOADER";

export const GET_CLOSE_ACT_PERMISSION = "GET_CLOSE_ACT_PERMISSION";

export const SET_POST_API_ACTION_ERROR = "POST_API_ACTION_ERROR_";
export const RESET_POST_API_ACTION_ERROR_REQUEST = "RESET_POST_API_ACTION_ERROR_REQUEST";
export const RESET_POST_API_ACTION_ERROR_SUCCESS = "RESET_POST_API_ACTION_ERROR_SUCCESS";